import React from 'react';
import LiveChatPanel from './LiveChatPanel';
import { requestNotificationPermission } from '../utils/notify';

// Right-edge "Live Chat" vertical tab + sliding drawer that embeds
// LiveChatPanel. Only appears when Jonathan is online/busy AND a chat
// session exists. Chime + unread tracking live in the parent (state,
// refs, and polling effect).
export default function LiveChatRail({
  jonathanStatus,
  fdLiveChatSession,
  liveChatRailOpen,
  setLiveChatRailOpen,
  fdLiveChatHasUnread,
  fdLiveChatShared,
  supportSelectedEmployeeId,
  fdSupportEmployeesList,
  handleSelectSupportEmployee,
  documents,
  onOpenSopDocument,
}) {
  if (!(jonathanStatus === 'online' || jonathanStatus === 'busy') || !fdLiveChatSession) {
    return null;
  }

  return (
    <>
      {!liveChatRailOpen && (
        <button
          type="button"
          onClick={() => {
            requestNotificationPermission();
            setLiveChatRailOpen(true);
          }}
          className="fixed right-0 top-1/2 z-[88] -translate-y-1/2 rounded-l-lg bg-emerald-600 py-5 pl-3 pr-3 text-xs font-bold uppercase tracking-widest text-white shadow-lg hover:bg-emerald-700 transition-colors"
          style={{ writingMode: 'vertical-rl', textOrientation: 'mixed' }}
          aria-label="Open live chat"
        >
          <span className="relative">
            Live Chat
            {fdLiveChatHasUnread && (
              <span
                className="absolute -top-1 -right-2 inline-flex h-2.5 w-2.5 rounded-full bg-red-500 ring-2 ring-emerald-600"
                aria-hidden
              />
            )}
          </span>
        </button>
      )}
      {liveChatRailOpen && (
        <>
          <div
            className="fixed inset-0 z-[87] bg-black/35"
            aria-hidden
            onClick={() => setLiveChatRailOpen(false)}
          />
          <div
            className="fixed right-0 top-0 z-[88] flex h-full w-full max-w-md flex-col border-l border-gray-200 bg-white shadow-2xl"
            role="dialog"
            aria-modal="true"
            aria-label="Live chat"
          >
            <div className="flex items-center justify-between border-b border-gray-100 px-4 py-3">
              <div>
                <div className="text-sm font-semibold text-gray-900">Live Support Chat</div>
                <div className="mt-1 flex flex-wrap items-center gap-2">
                  <span
                    className={`inline-flex items-center gap-2 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${
                      jonathanStatus === 'online'
                        ? 'bg-green-50 text-green-800 border-green-200'
                        : jonathanStatus === 'busy'
                          ? 'bg-yellow-50 text-yellow-800 border-yellow-200'
                          : 'bg-gray-50 text-gray-800 border-gray-200'
                    }`}
                  >
                    <span
                      className={`h-2.5 w-2.5 rounded-full ${
                        jonathanStatus === 'online'
                          ? 'bg-green-500'
                          : jonathanStatus === 'busy'
                            ? 'bg-yellow-500'
                            : 'bg-gray-500'
                      }`}
                      aria-hidden
                    />
                    Status: {jonathanStatus === 'online' ? 'Online' : jonathanStatus === 'busy' ? 'Busy' : 'Offline'}
                  </span>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setLiveChatRailOpen(false)}
                className="rounded-full p-2 text-gray-500 hover:bg-gray-100"
                aria-label="Close live chat"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="min-h-0 flex-1 overflow-auto p-4">
              {fdLiveChatShared && (
                <LiveChatPanel
                  sharedChat={fdLiveChatShared}
                  selectedEmployeeId={supportSelectedEmployeeId}
                  employees={fdSupportEmployeesList}
                  onSelectEmployee={handleSelectSupportEmployee}
                  supportStatus={jonathanStatus}
                  showStatusBadge={false}
                  documents={documents}
                  onOpenSopDocument={onOpenSopDocument}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
